import React, { useEffect, useRef, useCallback } from "react";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import ipiranga from "./Images/ipiranga.png";
import vila from "./Images/vila.png";
import parquetuiuti from "./Images/parquetuiuti.png";
import vilaema from "./Images/vilaema.png";
import estacaooratorio from "./Images/estacaooratorio.png";
import viladasbelezas from "./Images/viladasbelezas.png";
import { IoMdSwap } from "react-icons/io";

export default function ConstructionEmbla() {
  const slides = [
    {
      img: vila,
      title: "Vila Prudente II",
      description: (
        <>
          Em parceria com a Metrocasa, iniciamos mais esse empreendimento em São Paulo. São <span className="s">
            235 unidades habitacionais</span>, <span className="s">8.657,16 m2</span> de área construida, <span className="s">
            28 pavimentos construídos</span> pelo <span className="s">sistema de parede de concreto</span>. Este projeto é mais uma demonstração do compromisso da H2L com a inovação e a qualidade em cada etapa da construção.
        </>
      ),
      link: "https://www.metrocasa.com.br/imoveis/vila-prudente",
    },
    {
      img: ipiranga,
      title: "Alto do Ipiranga",
      description: (
        <>
          Localizado em São Paulo, o empreendimento conta com{" "}
          <span className="s">184 unidades habitacionais</span> e uma área total de{" "}
          <span className="s">6.609,84 m²</span>. Este projeto reflete o compromisso da H2L com a excelência e a inovação, oferecendo soluções residenciais que atendem às necessidades e expectativas dos seus futuros moradores.
        </>
      ),
      link: "https://www.metrocasa.com.br/imoveis/alto-do-ipiranga-2",
    },
    {
      img: parquetuiuti,
      title: "Res. Parque Tuiuti",
      description: (
        <>
          Em parceria com a Jeronimo da Veiga, a H2L executa o projeto do Residencial Parque Tuiuti, localizado em Belford Roxo/RJ. São{" "}
          <span className="s">288 unidades habitacionais</span> divididas em 10 blocos de 4 pavimentos, construídos pelo sistema de parede de concreto, totalizando uma área de{" "}
          <span className="s">12.187,79 m²</span>. O projeto integra o programa Minha Casa Minha Vida.
        </>
      ),
      link: "https://www.jeronimodaveiga.com.br/",
    },
    {
      img: vilaema,
      title: "Avenida Vila Ema",
      description: (
        <>
          Em parceria com a Metrocasa, a H2L está presente em mais um grande projeto na zona leste de São Paulo. São{" "}
          <span className="s">344 unidades habitacionais</span> distribuídas em 18 pavimentos, construídos em alvenaria estrutural, com uma área total de{" "}
          <span className="s">11.634,28 m²</span>. O empreendimento Metrocasa Avenida Vila Ema combina localização estratégica, mobilidade urbana e qualidade de vida.
        </>
      ),
      link: "https://www.metrocasa.com.br/imoveis/avenida-vila-ema?gad_source=1&gbraid=0AAAAAC3rd5Us1JwKOGQcqRT8y4IwFnBtd&gclid=CjwKCAjwwqfABhBcEiwAZJjC3h2ITFUcbzmwyp1nYLQjdg7vs2JVi6Yq3razmbUBcex10LuKIhbUexoCuywQAvD_BwE",
    },
    {
      img: estacaooratorio,
      title: "Estação Oratório",
      description: (
        <>
          Em parceria com a Metrocasa, iniciamos mais esse empreendimento em São Paulo. São{" "}
          <span className="s">531 unidades habitacionais</span>,{" "}
          <span className="s">17.422,85 m²</span> de área construída, 30 pavimentos construídos pelo sistema de parede de concreto. Este projeto é mais uma demonstração do crescimento contínuo e orgânico da H2L, sempre com compromisso na excelência, inovação, qualidade, sustentabilidade e transparência em cada etapa da construção.
        </>
      ),
      link: "https://www.metrocasa.com.br/imoveis/estacao-oratorio",
    },
    {
      img: viladasbelezas,
      title: "Estação Vila das Belezas",
      description: (
        <>
          Em parceria com a Metrocasa, iniciamos mais esse empreendimento na zona sul de São Paulo. São <span className="s">414 unidades habitacionais</span>, <span className="s">12.692,27 m²</span> de área construída e 30 pavimentos executados em alvenaria estrutural. Este projeto reforça o crescimento consistente da H2L, com compromisso em excelência técnica, inovação e sustentabilidade em cada etapa da construção.
        </>
      ),
      link: "https://www.metrocasa.com.br/imoveis/estacao-vila-das-belezas",
    },
  ];

  const autoplay = useRef(Autoplay({ delay: 5000, stopOnInteraction: true }));
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { loop: true, skipSnaps: false },
    [autoplay.current]
  );

  const scrollPrev = useCallback(() => emblaApi && emblaApi.scrollPrev(), [emblaApi]);
  const scrollNext = useCallback(() => emblaApi && emblaApi.scrollNext(), [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    emblaApi.on("select", () => { });
  }, [emblaApi]);

  return (
    <div className="embla construction-embla">
      <h2 className="textboard">Obras em andamento</h2>
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {slides.map(({ img, title, description, link }, index) => (
            <div className="embla__slide" key={index}>
              <div className="slide-content">
                <button
                  className="embla__button embla__button--prev"
                  onClick={scrollPrev}
                  aria-label="Previous Slide"
                >
                  ‹
                </button>
                <div className="columnslide">
                  <div className="slide-image-wrapper">
                    <img className="slide-img" src={img} alt={title} />
                  </div>
                  <div className="slide-text">
                    <IoMdSwap className="swap" />
                    <h2 className="titleap">{title}</h2>
                    <hr className="hrrh" />
                    <p className="subtitleap">{description}</p>
                    <a href={link} target="_blank" rel="noreferrer">
                      <button className="projeto">VISUALIZAR PROJETO</button>
                    </a>
                  </div>
                </div>
                <button
                  className="embla__button embla__button--next"
                  onClick={scrollNext}
                  aria-label="Next Slide"
                >
                  ›
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
